import React from 'react';
import JobScheduleForm from './JobScheduleForm';
import MultipleJob from './MultipleJob';

import {
    SESSION_USER,
    APP_DATE_AND_TIME_FORAMT,
    DATE_FORAMT,
    TIME_FORMAT,
    BLANK_SPACE,
    SSO_PARAMS
} from '../../constants';
import {
    getScheduleById,
    insertOrUpdateSchedule,
    editRecurringSchedule,
    deleteRecurringSchedule,
    getAllScheduleEvent,
    saveAllSchedule, getAllTeam
} from '../../util/APIUtils';
import moment from 'moment';
import $ from 'jquery';
import 'jquery-validation';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-ui-dist/jquery-ui.css';
import 'fullcalendar-scheduler';
import 'bootstrap';
import 'fullcalendar/dist/fullcalendar.min.css';

import 'fullcalendar-scheduler/dist/scheduler.min.css';
import 'timepicker';
import 'timepicker/dist/jquery.timepicker.css'
import GoogleMapForm from './GoogleMapForm';



class Calendar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            resources: [],
            loading: true,
            modalShow: false,
            selectedSkill: [],
            optionPeopleList: '',
            messageText: '',
            showMessage: false,
            teamsResponse: [],
        };

        this.handlePeopleChange = this.handlePeopleChange.bind(this);
        this.handleRouteChange = this.handleRouteChange.bind(this);
        this.handleJobChange = this.handleJobChange.bind(this);
        this.handleEquipmentChange = this.handleEquipmentChange.bind(this);
        this.handleTeamChange = this.handleTeamChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.updateCalendarEvents = this.updateCalendarEvents.bind(this);
        //    console.log(this.props);

      //  this.initeachevent=this.initeachevent.bind(this);   
       // this.createExternalEvent=this.createExternalEvent.bind(this);  


    }

    componentDidMount() {
        let $this = this;
        var defaultEventDuration = '02:00';
        var workingfromtime = '08:00';
        var workingtotime = '18:00';
        let user = JSON.parse(localStorage.getItem(SESSION_USER));
        // console.log(user);
        if (user.setting) {
            defaultEventDuration = user.setting.defaultEventDuration;
            workingfromtime = user.setting.fromtime;
            workingtotime = user.setting.totime;
        }


        var resourcesObject = this.props.resources;
        var childResourcesObject = this.props.resources;
        var teamsResponseObj = this.props.teamsResponse;
        var nowtime = this.props.nowdatetime;

        //----------------------------------Start Modal Confirm funcation--------------------------------
        var modalConfirm = function(callback) {

            $("#saveevent").off('click').click(function() {

                var val = $('#jobscheduleform').valid();
                if (val) {
                    var eventFcId = localStorage.getItem('eventFcId');
                    if (eventFcId) {

                        localStorage.removeItem('eventFcId');
                        var eventObj = $("#calendar").fullCalendar('clientEvents', eventFcId)[0];
                        // eventObj.title=$("#title").val();
                        var startAsString = $("#fromdate").val() + BLANK_SPACE + $("#fromtime").val();
                        var fromDateObject = moment(startAsString, APP_DATE_AND_TIME_FORAMT);
                        var endAsString = $("#todate").val() + BLANK_SPACE + $("#totime").val();
                        var endDateObject = moment(endAsString, APP_DATE_AND_TIME_FORAMT);
                        //  eventObj.resourceId=selectedPeoples.value;
                        eventObj.start = fromDateObject;
                        eventObj.end = endDateObject;

                        var fields = {};
                        fields['fromdate'] = $("#fromdate").val();
                        fields['fromtime'] = $("#fromtime").val();
                        fields['todate'] = $("#todate").val();
                        fields['totime'] = $("#totime").val();
                        fields['peopleId'] = eventObj.resourceId;

                        var eventId = eventObj.id.split("_");
                        fields['id'] = eventId[0];
                        arrayOfEvents.push(fields);
                        //console.log(arrayOfEvents);
                        calendarDragEvents.push(eventObj.id);
                        //eventObj.id=eventObj.id+'_w_id';
                        $('#calendar').fullCalendar('updateEvent', eventObj);
                    } else {
                        var newEvent = new Object();
                        //  newEvent.title = $("#title").val();
                        var startAsString = $("#fromdate").val() + BLANK_SPACE + $("#fromtime").val();
                        var fromDateObject = moment(startAsString, APP_DATE_AND_TIME_FORAMT);
                        var endAsString = $("#todate").val() + BLANK_SPACE + $("#totime").val();
                        var endDateObject = moment(endAsString, APP_DATE_AND_TIME_FORAMT);
                        //    newEvent.resourceId=selectedPeoples.value;
                        newEvent.start = fromDateObject;
                        newEvent.end = endDateObject;
                        // newEvent.id=response.id;
                        $('#calendar').fullCalendar('renderEvent', newEvent);
                    }
                    callback(true);
                    $("#add-new-event").modal('hide');
                    document.getElementById("jobscheduleform").reset();
                }

            });

            $("#closeevent").off('click').click(function() {
                callback(false);
                $("#add-new-event").modal('hide');
                document.getElementById("jobscheduleform").reset();

            });

            $("#deleteevent").off('click').click(function() {
            var val = $('#editjobscheduleform').valid();
                if (val) {  
                   var deleteeventId=$("#editid").val();
                 deleteRecurringSchedule(deleteeventId)
                    .then(response => {   
                          if(!response.success){
                            for(var k in response.deleteEvents){
                                  var calEvent=response.deleteEvents[k];
                                   $('#calendar').fullCalendar('removeEvents', calEvent);
                              }
                             
                            callback(true);
                            $("#multiple-event").modal('hide');
                            document.getElementById("editjobscheduleform").reset();
                          }

                     });
                }
  
            }); 

            $("#editsaveevent").off('click').click(function() {
                var val = $('#editjobscheduleform').valid();
                if (val) {  
                    var fields = {};
                    fields['fromdate'] = $("#editfromdate").val();
                    fields['fromtime'] = $("#editfromtime").val();
                    fields['recurringaction'] = $("#recurringaction").val();
                    fields['id'] = $("#editid").val();
                    fields['workOrderId'] = $("#workorderid").val();
                    fields['recurrnceId'] = $("#recurrnceId").val();
                    fields['peopleId'] = $("#peopleId").val();
                    editRecurringSchedule(fields)
                    .then(response => {   
                          if(!response.success){
                            //$('#calendar').fullCalendar('removeEvents', response.deleteEvents);
                           // $('#calendar').fullCalendar('addEventSource', response.createdEvents);
                              for(var k in response.deleteEvents){
                                  var calEvent=response.deleteEvents[k];
                                   $('#calendar').fullCalendar('removeEvents', calEvent);
                              }
                              for(var v in response.createdEvents){
                                  var addcalEvent=response.createdEvents[v];
                                   $('#calendar').fullCalendar('addEventSource', addcalEvent);
                              }
                            callback(true);
                            $("#multiple-event").modal('hide');
                            document.getElementById("editjobscheduleform").reset();
                          }

                     });
                }
                   
            });

            $("#editcloseevent").off('click').click(function() {
                callback(false);
                $("#multiple-event").modal('hide');
                document.getElementById("editjobscheduleform").reset();

            });

        };
        //----------------------------------End Modal Confirm funcation--------------------------------


    function createExternalEvent(priority,title,scheduleId,time){
     var texthtml='<div class="calendar-events"  data-time="'+time+'"  data-title='+title+'  data-priority='+priority+' id='+scheduleId+'><i class="ti-menu threeline"></i>'+title+'';
     texthtml+='<br/><small><i class="mdi mdi-av-timer"></i>'+time+'&nbsp;Hours</small></div>';
     $('#calendar-event').append(texthtml);
     initeachevent();

        // var eventId=$(this).attr('id');
        //var priority=$(this).attr('priority');
         //var title=$(this).attr('title');
    }
    function initeachevent(){
      $('#calendar-event .calendar-events').each(function() {  
           var eventId=$(this).attr('id');
          // console.log(eventId);
            $(this).data('event', {
                title: $.trim($(this).text()), 
                id:eventId,
               // defaultTimedEventDuration:$(this).data('defaultTimedEventDuration'),
                stick: true 
            });
            $(this).draggable({
              //  appendTo: 'body',
               // containment: 'page-wrapper',
                scroll: false,
                helper: 'clone',
                zIndex: 999,
                revert: true,      
                revertDuration: 0  
            });
        });
        
    }
        function showpopup(externalEventObject, eventId) {
            //  $('#add-new-event').modal('show');
            $('#add-new-event').modal({
                backdrop: 'static',
                keyboard: false
            });
            var result = modalConfirm(function(confirm) {
                if (confirm) {
                     var data={
                      time:externalEventObject.data('time'),
                      title:externalEventObject.data('title'),
                      priority:externalEventObject.data('priority'),
                      id:eventId
                     }
                    //console.log(data);
                    calendarDragObjects.push(data);
                    externalEventObject.remove();
                    return false;
                } else {
                    var ids = [eventId];
                    $('#calendar').fullCalendar('removeEvents', ids);
                    //console.log('No');
                    return false;

                }
            });
            return false;


        }

        function showMultipleJob(eventId) {
            $('#multiple-event').modal({
                backdrop: 'static',
                keyboard: false
            })

            var result = modalConfirm(function(confirm) {
                if (confirm) {
                    return false;
                } else {
                    return false;

                }
            });
            return false;


        }

        function showpopup2(eventId) {
            $('#add-new-event').modal({
                backdrop: 'static',
                keyboard: false
            })

            var result = modalConfirm(function(confirm) {
                if (confirm) {
                    return false;
                } else {
                    return false;

                }
            });
            return false;


        }


        var arrayOfEvents = [];
        var calendarDragEvents = [];
        var calendarDragObjects = [];
        var calendarview = this.props.calendarview;
        //alert(nowtime);
        $('#calendar').fullCalendar({
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
            titleFormat: "dddd, DD MMMM YYYY",
            defaultView: calendarview,
            nowIndicator: true,
            //     now: this.props.nowdatetime, // just for demo
            eventLimit: true,

            scrollTime: this.props.currenttime,
           eventConstraint: "businessHours",
            // events: this.state.events,
            buttonText: {
                today: 'Today',
            },
            customButtons: {
                saveevents: {
                    text: 'Save',
                    click: function() {
                        updateSchedule();
                    }
                },resetevents: {
                    text: 'Reset',
                    click: function() {
                        resetSchedule();
                    }
                }
            },
            header: {
                left: 'prev,today,next resetevents saveevents',
                center: 'title',
                right: 'timelineMonth,timelineWeek,timelineCustomWeek,timelineDay'

            },
            views: {
                timelineDay: {
                    buttonText: 'Day'
                },
                timelineWeek: {
                    buttonText: 'Week'
                },
                agendaDay: {
                    buttonText: 'Route'
                },
                timelineThreeDays: {
                    type: 'timeline',
                    duration: {
                        days: 3
                    }
                },
                timelineCustomWeek: {
                    type: 'timeline',
                    duration: {
                        weeks: 1
                    },
                    slotDuration: {
                        days: 1
                    },
                    buttonText: 'Week Collapsed'
                }

            },
            editable: false,
            eventClick: function(info) {
                if (info.title == 'Travel Time') return false;
                if (info.id) {
                    localStorage.setItem('eventFcId', info._id);
                    console.log(info);
                    loadpopup(info);
                }
            },
            resourceAreaWidth: '34%',
            resourceLabelText: 'Employee',
            resources: function (callback) {
                callback(childResourcesObject);
            },
            resourceRender: function(resourceObj, th) {


                // console.log(resourceObj);

                    var currentView = $("#calendar").fullCalendar('getView').name;
                    var image_url = '../static/assets/images/people.png';

                    if (typeof resourceObj.image_url != 'undefined') {
                        image_url = resourceObj.image_url;
                    }

                    if (currentView == 'agendaDay') {
                        if (th.find("span.fc-cell-text").length == 0) {
                            th.prepend('<img src="' + image_url + '" height="35px" width="35px" alt="user" style="border-radius:100%;border:0px solid ' + resourceObj.eventBackgroundColor + ';" class="profile-pic"><br/>');
                        } else {
                            th.find("span.fc-cell-text").prepend('<img src="' + image_url + '" style="border-radius:100%;border:0px solid ' + resourceObj.eventBackgroundColor + ';" height="35px" width="35px" alt="user" class="profile-pic"> <br/>');
                        }
                        th.css('background', resourceObj.eventBackgroundColor);
                        th.css('color', resourceObj.eventTextColor);
                        th.css('font-weight', '600');
                        th.css('font-size', '14px');
                    } else {
                        if (th.find("span.fc-cell-text").length == 0) {
                            th.prepend('<img src="' + image_url + '" height="35px" width="35px" alt="user" style="border-radius:100%;border:0px solid ' + resourceObj.eventBackgroundColor + ';" class="profile-pic"> ');
                        } else {
                            th.find("span.fc-cell-text").prepend('<img src="' + image_url + '" style="border-radius:100%;border:0px solid ' + resourceObj.eventBackgroundColor + ';" height="35px" width="35px" alt="user" class="profile-pic"> ');
                        }
                    }

                    if (currentView == 'timelineDay') {
                        var currentDate = $('#calendar').fullCalendar('getDate');

                        var fromdate = currentDate.format(DATE_FORAMT);
                        // console.log(fromdate);
                        th.find("span.fc-cell-text").append('<button type="button" data-currentDate="' + fromdate + '" data-resourseId="' + resourceObj.id + '" style="float:right;color:' + resourceObj.eventTextColor + ';border:1px solid ' + resourceObj.eventBackgroundColor + ';background:' + resourceObj.eventBackgroundColor + '" class="buildroutes btn waves-effect waves-light btn-rounded btn-sm btn-primary"><i class="fa fa-map-marker buildroutes"></i></button>');
                    }

            },

            defaultTimedEventDuration: defaultEventDuration,
            events: this.props.schedules,
            eventAllow: function(dropLocation, draggedEvent) {



            },
            eventRender: function(event, element) {
                var title = element.find('.fc-title');
                var val = title.text();
                //console.log(val);

                title.html(escapeHtml(val));
                if (val == 'Travel Time') {
                    var travleTitle = '<span style="font-style:italic;">Travel Time</span>';
                    title.html(travleTitle);
                }
                //  alert('eventRender');
                //  console.log('-----------------eventRender Start-------------------------');
                //  console.log(info);
                //  console.log('-----------------eventRender End-------------------------');
            },
            droppable: true,
            drop: function(date, jsEvent, ui, resourceId) {
                document.getElementById("jobscheduleform").reset();
                var start = date.format();
                var defaultDuration = moment.duration($('#calendar').fullCalendar('option', 'defaultTimedEventDuration'));
                var end = date.clone().add(defaultDuration); // on drop we only have date given to us
                // localStorage.setItem("eventId",this.id);
                var eventId = this.id;
                if (start) {
                    var fromdate = moment(start).format(DATE_FORAMT);
                    var fromtime = moment(start).format(TIME_FORMAT);
                    $('#fromdate').val(fromdate);
                    $('#fromtime').val(fromtime);
                }
                if (end) {
                    var todate = moment(end).format(DATE_FORAMT);
                    var totime = moment(end).format(TIME_FORMAT);
                    $('#todate').val(todate);
                    $('#totime').val(totime);
                }
                
                showpopup($(this), eventId); //open popup 

            },
            eventReceive: function(event) {
                localStorage.setItem('eventFcId', event._id);
            }
        })


          let  innerHTML = "<select class=\"selectpicker form-control-sm\" id = \"select-group-picker\"  title=\"Select Group\">";

        // innerHTML +=  "<option data-hidden=\"true\"></option>";
        innerHTML += "<option value=\"0\">Select Group</option>";

        for(var i = 0; i < teamsResponseObj.length; i++) {
                innerHTML += "<option value=\"" + i + "\">" + teamsResponseObj[i].name + "</option>";
            };
        innerHTML += "</select>"

        // search employee
        $(".fc-header-toolbar").append('<div class="container mt-1 mb-3">\n' +
            '  <div class="row w-100">\n' +
            '  <div class="col"></div>\n' +
            '    <div class="col-6">\n' +
            '      <div class="input-group input-group-sm">\n' +
            '            <input type="search" id="emp-search-input" class="form-control rounded pl-1" placeholder="Search Employee" aria-label="Search" aria-describedby="search-addon" />\n' +
            '            <button type="button" id="emp-search-button" class="searchButton mt-1"><img src="https://img.icons8.com/ios-glyphs/30/000000/search--v1.png"/></button>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '    <div class="col-3">\n' +
            '      <div class="input-group mt-1">\n' +
            innerHTML       +
            '        </div>\n' +
            '    </div>\n' +
            '  </div>\n' +
            '</div>')

        $("#emp-search-button").on("click", function(event) {
            var searchVal=$('#emp-search-input').val();
            console.log('search button value: ', searchVal);
            childResourcesObject = [];

            if(searchVal){
                resourcesObject.filter(function(person){
                    if (person.title.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) {
                        console.log('search person found: ', person.title)
                        childResourcesObject.push(person);
                    }
                });

               // $('#calendar').fullCalendar('destroy');

            } else {
                childResourcesObject=resourcesObject;
            }
            $('#calendar').fullCalendar('refetchResources');

            //$('#calendar').fullCalendar('gotoDate', "2018-"+this.value+"-1");
        });

        $("#select-group-picker").on("change", function(event) {
            var searchVal = $('#select-group-picker').val();
            console.log('search group value: ', searchVal);
            childResourcesObject = [];

            if(searchVal && searchVal !== "0"){
                resourcesObject.filter(function(person){
                    teamsResponseObj[searchVal].peoples.forEach(function (item){
                            if (item.id === person.id) {
                                console.log('search group found: ', person.title)
                                childResourcesObject.push(person);
                            }
                    });
                });

                // $('#calendar').fullCalendar('destroy');

            } else {
                childResourcesObject=resourcesObject;
            }
            $('#calendar').fullCalendar('refetchResources');

        });


        function resetSchedule(){
              console.log(calendarDragObjects);
               
             console.log(calendarDragEvents);
             //  return false;
              if(calendarDragObjects){
                for(var k in calendarDragObjects){
                       var dragEvent=calendarDragObjects[k];
                       createExternalEvent(dragEvent['priority'],dragEvent['title'],dragEvent['id'],dragEvent['time']);
                }
              }
              if(calendarDragEvents){
                  for(var k in calendarDragEvents){
                      var calEvent=calendarDragEvents[k];
                       $('#calendar').fullCalendar('removeEvents', calEvent);
                  }
              }
               arrayOfEvents = [];
               calendarDragEvents=[]; 
               calendarDragObjects=[];
        }

        function updateSchedule() {
            saveAllSchedule(arrayOfEvents).then(response => {
                if (response) {
                  //  $('#calendar').fullCalendar('removeEvents', calendarDragEvents);
                    $('#calendar').fullCalendar('addEventSource', response);
                     if(calendarDragEvents){
                          for(var k in calendarDragEvents){
                              var calEvent=calendarDragEvents[k];
                               $('#calendar').fullCalendar('removeEvents', calEvent);
                          }
                     }
                     arrayOfEvents = [];
                    calendarDragEvents=[]; 
                    calendarDragObjects=[];
                }
                arrayOfEvents = [];
            }).catch(error => {
                alert("error")
            });
        }

        function escapeHtml(unsafe) {
            if (unsafe == null) {
                return "";
            }
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }


        function loadpopup(data) {
          //  let user = JSON.parse(localStorage.getItem(SESSION_USER));
            getScheduleById(data.id)
                .then(response => {
                    if (response) {
                        $('#editid').val(response.id);
                        $('#peopleId').val(data.resourceId);
                       // $('#title').val(response.title);
                        $('#recurringaction').val('THIS_EVENT');
                        $('#recurrnceId').val(response.recurrnceId);
                        if (response.fromDate) {
                            var fromdate = moment(response.fromDate, APP_DATE_AND_TIME_FORAMT).format(DATE_FORAMT);
                            var fromtime = moment(response.fromDate, APP_DATE_AND_TIME_FORAMT).format(TIME_FORMAT);
                            $('#editfromdate').val(fromdate);
                            $('#editfromtime').val(fromtime);
                        }
                        if(response.workOrder){
                           $('#workorderid').val(response.workOrder.id);
                        }

                        
                        $("label.error").hide(); //hide error message jobscheduleform
                        showMultipleJob(data.id); //open popup
                    }
                }).catch(error => {
                    alert("Error in getScheduleById  function");
                });


        }
        localStorage.removeItem(SSO_PARAMS);
        /*-----------------------------------------STOP ON LOAD POPUP CREATOR TO SS (SSO)--------------------------------------------------------*/

        $('#date-daily').change(function() {
            var selectedDate = $('#date-daily').val();
            var view = $('#calendar').fullCalendar('getView');
            // alert("The view's title is " + view.name);

            $('#calendar').fullCalendar('changeView', view.name);
            selectedDate = moment(selectedDate, "MM/DD/YYYY").format("MM/DD/YYYY");
            $('#calendar').fullCalendar('gotoDate', selectedDate);

        });


        if (this.props.calendarview == 'agendaDay') {
            $('.fc-right').css('display', 'none');
        }




    }

    updateCalendarEvents() {
        let user = JSON.parse(localStorage.getItem(SESSION_USER));
        getAllScheduleEvent(user.id).then(response => {
            //console.log(response);
            if (response.schedules) {
                $('#calendar').fullCalendar('removeEvents');

                $('#calendar').fullCalendar('addEventSource', response.schedules);

            }

        }).catch(error => {
            if (error.status === 404) {
                this.setState({
                    notFound: true,
                });
            } else {
                this.setState({
                    serverError: true,
                });
            }
        });




    }

    handlePeopleChange() {
        $('#calendar').fullCalendar('changeView', 'timelineDay');
        $("#routeview").removeClass("active");
        $("#peopleview").addClass("active");
        $('.fc-right').css('display', 'block');
    }
    handleJobChange() {
        window.location.href = '/jobschedule';
    }

    handleEquipmentChange() {
        window.location.href = '/equipmentview';
    }

    handleTeamChange() {
        window.location.href = '/teamview';
    }

    handleLocationChange() {
        window.location.href = '/locationview';
    }

    handleRouteChange() {
        $('#calendar').fullCalendar('changeView', 'agendaDay');
        $("#peopleview").removeClass("active");
        $("#routeview").addClass("active");
        $('.fc-right').css('display', 'none');
    }


    render() {

        const travelEventBgColor = this.props.travelEventBgColor;
        const travelEventStyle = {
            color: travelEventBgColor
        }

        var className = '';
        if (this.props.calendarview == 'agendaDay') {

        }

                return <div className="col-md-9">

                <div className="card">
                <div className="card-body">
                <div className="row1">
                <div style={{float:'left'}}>



                <div className="view-by-items-block">

                <span style={{cursor:'pointer',display:'none'}} onClick={this.handleJobChange} className="view-by-item">
                <i className="icon-list"></i><button style={{display:'none1'}} type="button" id="jobview" onClick={this.handleJobChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Job</button>
                </span>

                <span style={{cursor:'pointer'}} onClick={this.handlePeopleChange} className="view-by-item"  >
                <i className="icon-user active"></i><button type="button" id="peopleview" onClick={this.handlePeopleChange} className={this.props.calendarview=='agendaDay' ? 'btn waves-effect waves-light btn-outline-success btn-rounded btn-xs':'active btn waves-effect waves-light btn-outline-success btn-rounded btn-xs'}>Employee</button>
                </span>

                <span style={{cursor:'pointer'}} onClick={this.handleRouteChange} className="view-by-item" style={{display:'none'}}>
                <i className="fa fa-user-o "></i><button type="button" id="routeview" onClick={this.handleRouteChange} className={this.props.calendarview=='agendaDay' ? 'active btn waves-effect waves-light btn-outline-success btn-rounded btn-xs':'btn waves-effect waves-light btn-outline-success btn-rounded btn-xs'}>Route</button>
                </span>

                <span style={{cursor:'pointer'}} onClick={this.handleEquipmentChange} className="view-by-item">
                <i className="icon-settings"></i><button type="button" id="equipmentview" onClick={this.handleEquipmentChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Equipment</button>
                </span>

                <span style={{cursor:'pointer'}} onClick={this.handleTeamChange} className="view-by-item">
                <i className="icon-people"></i><button type="button" id="teamview" onClick={this.handleTeamChange} className="btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Crew</button>
                </span>

                <span style={{cursor:'pointer'}} onClick={this.handleLocationChange} className="view-by-item">
                <i className="icon-location-pin"></i><button type="button" id="locationview" onClick={this.handleLocationChange} className=" btn waves-effect waves-light btn-outline-success btn-rounded btn-xs">Location</button>
                </span>
                </div>
                </div>
                

                <div style={{float:'right'}}>&nbsp;&nbsp;&nbsp;&nbsp; <input type="text" id="date-daily" placeholder="Select the date"  style={{width:'115px',position:'relative',zIndex: '10',height:'24px',border:'1px solid grey',color:'#333',borderRadius:'3px'}} /></div> &nbsp;&nbsp;


                <div style={{float:'right',fontSize:'13px'}}><i className="fa fa-circle" style={{color:'rgb(196, 194, 193)'}}></i>  Off Hours  </div> &nbsp;&nbsp;
                <div style={{float:'right',fontSize:'13px'}}><i className="fa fa-circle" style={travelEventStyle}></i>  Travel Time   &nbsp;&nbsp;</div>


                </div>

                <div id="calendar" style={{clear:'both'}}></div>


                <JobScheduleForm fields={this.props.fields} states={this.state}/>

                    <MultipleJob fields={this.props.fields} states={this.state}/>
                
                <GoogleMapForm  updateCalendarEvents={this.updateCalendarEvents}/>
                </div>
                </div>
                </div>;
              }
            }

            export default Calendar;
